// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2ljqC","col":"styles_col__WLHsz","fulfillmentStatus":"styles_fulfillmentStatus__I3xBt","emailCol":"styles_emailCol__3jTvV"};